import {
  getFilesURLs,
  getTendersURLs,
  getTenderVersionedFile,
  GetTenderVersionedFileParams,
  newSingleTenderDownload,
  newSingleTenderFolderFileDownload,
} from '~src/services/api';
import { saveFromLink } from '~src/utils/downloader/shared/saveFromLink';
import { DownloadingState, useStore } from '~src/store';
import { message } from 'antd';
import { appLog } from '~src/utils/log';

const createWorker = () => {
  return new Worker(
    URL.createObjectURL(
      new Blob(
        [
          `self.onmessage = async (event) => {
            const { file } = event.data;
            try {
              const response = await fetch(file.url);
              
              if (!response.ok) {
                throw new Error(\`HTTP \${response.status} - \${response.statusText}\`);
              }

              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              
              self.postMessage({ success: true, file, url });
            } catch (error) {
              console.error(\`Worker Error - File: \${file.file_name}, Error: \${error.message}\`);
              self.postMessage({ success: false, file, error: error.message });
            }
          };`,
        ],
        { type: 'application/javascript' }
      )
    )
  );
};

export const downloadVersionedFolderFile = async (
  projectId,
  tenderId,
  rootFolderId,
  folderId,
  registrationId,
  serial,
  onDownloadStarted
) => {
  // Signal that download has started
  useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);
  appLog(
    'downloadVersionedFolderFile',
    tenderId,
    projectId,
    rootFolderId,
    folderId
  );

  if (!tenderId) throw new Error(`No tender id`);
  if (!projectId) throw new Error(`No tender id`);
  if (!registrationId) throw new Error(`No registrationId id`);

  const registrationKey = await newSingleTenderFolderFileDownload(
    'registration key',
    {
      projectId: Number(projectId),
      tenderId: Number(tenderId),
      rootFolderId: rootFolderId,
      folderId: folderId,
      registration_ids: registrationId,
      serial: serial,
    }
  );

  appLog(`registrationKey`, registrationKey);

  // Now, obtain the full URL (if you need to call another endpoint like getTendersURLs,
  // you can reuse a similar approach to your existing function).
  // For example, if getTendersURLs is used to finalize the file download URL:
  const fileUrl = await getTendersURLs(
    projectId,
    tenderId,
    registrationKey.map((key) => key.using_key)
  );

  const worker = createWorker();
  const selectedFile = {
    file_name: registrationKey[0].file_name,
    url: fileUrl[0].url,
  };

  worker.postMessage({ file: selectedFile });
  worker.onmessage = (event) => {
    const { success, file, url, error } = event.data;
    if (success) {
      onDownloadStarted && onDownloadStarted();
      saveFromLink(url, file.file_name);
    } else {
      message.error(`ERROR: ${error}`);
      appLog(`Download failed for ${file.file_name}: ${error}`);
    }
    worker.terminate();
  };

  useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
  setTimeout(() => {
    useStore.getState().changeDownloadingActive(false);
  }, 3000);
};

// export const downloadVersionedFile = async (
//   args: GetTenderVersionedFileParams,
//   onDownloadStarted?: () => unknown
// ) => {
//   const fileLocation = await getTenderVersionedFile(args);
//   useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);
//
//   if (fileLocation) {
//     onDownloadStarted && onDownloadStarted();
//
//     saveFromLink(fileLocation.location, fileLocation.title);
//
//     useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
//     setTimeout(() => {
//       useStore.getState().changeDownloadingActive(false);
//     }, 3_000);
//   }
//
//   useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
//   setTimeout(() => {
//     useStore.getState().changeDownloadingActive(false);
//   }, 3_000);
// };
